import type { EnvVar, Warning } from '@/api/schemas';
import { cn } from '@/lib/utils';
import { Icon } from '@/components/Icon';
import { derivedWarnings } from './envHelpers';

const SEVERITY_CLASS: Record<Warning['severity'], string> = {
  error: 'border-failed/30 bg-failed/10 text-failed',
  warning: 'border-awaiting/30 bg-awaiting/10 text-awaiting',
  info: 'border-running/30 bg-running/10 text-running',
};

export function WarningChips({ v }: { v: EnvVar }) {
  const warnings = derivedWarnings(v);
  if (warnings.length === 0) return <span className="text-xs text-subtle">—</span>;
  return (
    <span className="flex flex-wrap gap-1">
      {warnings.map((w) => (
        <span key={w.code} data-testid={`env-warning-${w.code}`} title={w.message} className={cn('inline-flex items-center gap-1 rounded-md border px-1.5 py-px font-mono text-[11px]', SEVERITY_CLASS[w.severity])}>
          <Icon name={w.severity === 'info' ? 'info' : 'warning'} size={12} />
          {w.code}
        </span>
      ))}
    </span>
  );
}
